import { createContext, useContext, type ReactNode } from "react";
import { useMe } from "./useMe";
import type { Me } from "./api";

interface MeState {
  me: Me | null;
  loading: boolean;
  error: Error | null;
  refresh: () => Promise<void>;
}

const Ctx = createContext<MeState | null>(null);

/**
 * One /api/me fetch for the whole app.
 *
 * Every gated screen reads the same object, so a plan change after checkout needs
 * a single refresh() rather than each page discovering it separately — and the
 * app doesn't fire a duplicate request on every navigation.
 */
export function MeProvider({ children }: { children: ReactNode }) {
  const state = useMe();
  return <Ctx.Provider value={state}>{children}</Ctx.Provider>;
}

export function useMeContext(): MeState {
  const v = useContext(Ctx);
  if (!v) throw new Error("useMeContext must be used inside <MeProvider>");
  return v;
}
